export const HEADER_SUBDOMAIN_OVERRIDE = "x-if-subdomain";
